module.exports = __webpack_public_path__ + "assets/img/a56cd6209ed82e8fd725ece95a16fb35.png";